import { PUBLIC_ENV } from '$env/static/public';
import { sentry } from '$lib/env';

import * as Sentry from '@sentry/sveltekit';

Sentry.init({
	dsn: sentry.dsn,
	tracesSampleRate: PUBLIC_ENV === 'production' ? 0.1 : 0,
	environment: PUBLIC_ENV === 'production' ? 'production' : 'preview',
	sendDefaultPii: true,
	replaysSessionSampleRate: PUBLIC_ENV === 'production' ? 0.1 : 0,
});
export const handleError = Sentry.handleErrorWithSentry();
